import { REACT_APP_API } from '../../config'
import axios from 'axios'

export async function getCurrentLead(id) {
  const response = await axios.get(`${REACT_APP_API}/sirena/getCurrentLead/${id}`)
  return response
}